module.exports = __webpack_public_path__ + "img/playMind.d1d925bb.svg";